import { render, staticRenderFns } from "./vertical-container.vue?vue&type=template&id=60ae662c&scoped=true&"
import script from "./vertical-container.vue?vue&type=script&lang=js&"
export * from "./vertical-container.vue?vue&type=script&lang=js&"
import style0 from "./vertical-container.vue?vue&type=style&index=0&id=60ae662c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ae662c",
  null
  
)

export default component.exports